module.exports = __webpack_public_path__ + "media/styles/images/svg/checkbox-unchecked-gray-8a6749c380744d1b7f5321a1d7a647b3.svg";